import en from "./en.json";
import es from "./es.json";
import it from "./it.json";
import fr from "./fr.json";
import pl from "./pl.json";

const languages = { en, it, es, fr, pl };

export default languages;
